'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'sword';
var width = 576;
var height = 512;
var aliases = [128481];
var unicode = 'f71c';
var svgPathData = 'M272 384l48 48-32 32-112-48-48 48 0 48-32 32-96-96 32-32 48 0 48-48-48-112 32-32 48 48 288-288 112 0 0 112-288 288zm-33.9-33.9l273.9-273.9 0-44.1-44.1 0-273.9 273.9 44.1 44.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSword = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;